











































import AbpBase from "../../../lib/abpbase";
import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import {GetRecipeData,Prescribe,SaveDialySummary} from '../../../api/dialysisProcess'




@Component({
    components:{
    }
})
export default class  extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:Object,default:{}}) data:any;

    created(){
      
    }
    piclist:any = {}
    picConfirm(){
        
    }
   
    //表单值
    rules = {};
    form:any = {
        recipeId:null,
        summary:'',
        nSummary:'',
        remarks:'',
    }
    async save(){
        this.form.recipeId = this.data.recipeId
        let res  = await SaveDialySummary(this.form)
        if(res.status==1){
            this.$emit('input',false);
            this.$emit('on-back')
        }
    }


    //确认处方
   
    mounted() {
        
    }

    
    cancel(){
        // (this.$refs.roleForm as any).resetFields();
        this.$emit('input',false);
    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dialysisProcess/dialysisArea/dialysisSummary.vue